import type { Accommodation } from '../types';

export function bookingSearchUrl(stay: Accommodation): string {
  const query = [stay.name, stay.city, stay.state].filter(Boolean).join(', ');
  const params = new URLSearchParams({ ss: query });
  return `https://www.booking.com/searchresults.html?${params.toString()}`;
}
